'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var TextInput = styled__default['default'].input.withConfig({ displayName: "ww-uikit_TextInput_ls4hrcmd", componentId: "sc-xuftfd" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    background-color: transparent;\n    width: 100%;\n    margin: auto;\n    padding: 0 10px;\n    -webkit-appearance: none;\n    border: 1px solid ", ";\n    height: 48px;\n    line-height: 30px;\n    border-radius: 0;\n    &:disabled {\n        background: ", ";\n        color: ", ";\n        opacity: 1;\n    }\n"], ["\n    background-color: transparent;\n    width: 100%;\n    margin: auto;\n    padding: 0 10px;\n    -webkit-appearance: none;\n    border: 1px solid ", ";\n    height: 48px;\n    line-height: 30px;\n    border-radius: 0;\n    &:disabled {\n        background: ", ";\n        color: ", ";\n        opacity: 1;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal20;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal3;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var templateObject_1;

exports.default = TextInput;
//# sourceMappingURL=index.js.map
